import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import CtaBand from "@/components/CtaBand";
import ProcessTimeline from "@/components/ProcessTimeline";
import { standFor } from "@/data/site";

export default function HowWeWork() {
  return (
    <>
      <Seo
        title="How We Work | Incremental Consulting"
        description="A structured path from mandate to confidence: understand, assess, deliver, evidence, sustain."
      />
      <section className="bg-[#0B1F3A]">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-24">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#C9A227]" data-testid="hww-eyebrow">How We Work</p>
            <h1 className="mt-3 max-w-3xl text-balance font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl" data-testid="hww-title">
              A structured path from mandate to confidence.
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/70">
              Every engagement follows the same disciplined arc — scaled to the size and complexity of the programme. Structure creates confidence; evidence keeps it honest.
            </p>
          </Reveal>
        </div>
      </section>
      <section className="bg-[#F5F8FC]">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-24">
          <ProcessTimeline />
        </div>
      </section>
      <section className="bg-white">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-24">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#A87B1F]">What We Stand For</p>
            <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-[#0B1F3A] sm:text-3xl">How we show up.</h2>
          </Reveal>
          <div className="mt-10 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
            {standFor.map((v, i) => (
              <Reveal key={v.title} delay={i * 0.1}>
                <div>
                  <span className="block h-0.5 w-10 bg-[#C9A227]" />
                  <h3 className="mt-4 font-display text-lg font-bold text-[#0B1F3A]">{v.title}</h3>
                  <p className="mt-2 text-[13.5px] leading-relaxed text-[#667085]">{v.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
